import type { Environment } from '@bcf-shared-settings/settings/types';
import { environmentBase } from '@env/envs/sportsbook/lvbetpl/environment.base';

export const environment: Environment = {
  ...environmentBase,
  production: true,
  userApiUrl: 'https://user.lvbet.pl/',
  walletApiUrl: 'https://wallet.lvbet.pl/',
  paymentApiUrl: 'https://payment.lvbet.pl/',
  cmsApiUrl: {
    default: 'https://lvbet.pl/'
  },
  cmsHeadlessApiUrl: 'https://cms.lvbet.pl/',
  shadowStylesUrl: {
    default: 'https://lvbet-static.com/shadow-css/',
    'mobile-web': 'https://m.lvbet.pl/shadow-css/',
    'mobile-capacitor': 'https://m.lvbet.pl/shadow-css/'
  },
  cpSocketUrl1: 'wss://ws.lvbet.pl/register',
  feApiUrl: 'https://lvbet.pl'
};
